import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';

import {
  DonateBannerComponent,
  DonateFormComponent
} from './components';

import {DonateComponent} from './donate.component'

const DonateComponents = [DonateBannerComponent, DonateFormComponent,DonateComponent]

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: DonateComponents,
  exports: DonateComponents
})
export class DonateModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/donate.module.ts